import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import guideAvatar from "../Assets/he-landing/guide-avatar.png";
import { setPostAuthRedirect } from "../../utils/postAuthRedirect";
import "./ChatbotButton.css";

// Asks a logged-out visitor to log in or sign up before chatting, then sends
// them back to /chat once they have an account (chat > sign up > chat)
export default function ChatLoginPrompt({ open, onClose }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open, onClose]);

  if (!open) return null;

  // The login panel lives on /main: it opens from this flag when /main
  // mounts, or from the event when the visitor is already there
  const openLogin = () => {
    onClose();
    setPostAuthRedirect("/chat");
    localStorage.setItem("openLoginPanel", "true");
    if (window.location.pathname.replace(/\/+$/, "").endsWith("/main")) {
      window.dispatchEvent(new Event("xianhe:open-login"));
    } else {
      navigate("/main");
    }
  };

  const openSignUp = () => {
    onClose();
    setPostAuthRedirect("/chat");
    navigate("/signup");
  };

  return (
    <div className="chatbot-guest-overlay" onClick={onClose}>
      <div
        className="chatbot-guest-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="chatbot-guest-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="chatbot-guest-close"
          aria-label={t("mainPage.close", "Close")}
          onClick={onClose}
        >
          ×
        </button>
        <img className="chatbot-guest-avatar" src={guideAvatar} alt="" width="72" height="72" />
        <h2 id="chatbot-guest-title">{t("chatbotGuest.title", "Talk with Hé")}</h2>
        <p>
          {t("chatbotGuest.message", "Log in or create a free account to start your conversation with Hé.")}
        </p>
        <div className="chatbot-guest-actions">
          <button type="button" className="chatbot-guest-primary" onClick={openLogin} autoFocus>
            {t("mainPage.logIn", "Log In")}
          </button>
          <button type="button" className="chatbot-guest-secondary" onClick={openSignUp}>
            {t("loginPage.signUp", "Sign Up")}
          </button>
        </div>
      </div>
    </div>
  );
}
